import React from 'react'
import { useInstData } from 'tyan/public/hooks'

let RTEDialog

export default props => {
	const { me, setState } = useInstData()

	const doLoad = async () => {
		const m = await import(/* webpackChunkName: "chunks/public/fb/RTE" */ './RTEDialog')
		m && m.default && (RTEDialog = m.default)
		setState({})
	}

	!RTEDialog && doLoad()

	return RTEDialog && <RTEDialog {...props} /> || null
}
